import { ComponentProps } from "react";
import { styled } from "@mui/material/styles";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const RawToggleButtonGroup = styled(MuiToggleButtonGroup)(() => ({
}));

export function ToggleButtonGroup(props: ComponentProps<typeof MuiToggleButtonGroup>) {
    const { size = 'small', ...rest } = props;
    return (
        <RawToggleButtonGroup size={size} {...rest} />
    );
}

export default ToggleButtonGroup;